import { Component, OnInit } from '@angular/core';
import { NotificationService, Notification } from '@app/services/notification.service';
import { isArray } from 'lodash';
import { Observable } from 'rxjs/internal/Observable';
import { shareReplay } from 'rxjs/operators';

@Component({
    selector: 'syn-notification',
    templateUrl: 'notification.component.html'
})

export class NotificationComponent implements OnInit {

    public notifications$: Observable<Notification[]>;
    public isArray = isArray;

    constructor(
        private notificationService: NotificationService,
    ) { }

    ngOnInit() {
        this.notifications$ = this.notificationService.notifications$.pipe(shareReplay(1));
    }
}
